// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GapsyShariahList_pageContainer__xrF-h {
    max-width: 1200px;
    margin: auto;
    padding: 20px;
}

/* Header */

.GapsyShariahList_header__itBy6 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    flex-wrap: wrap;
    gap: 15px;
}

.GapsyShariahList_title__4Mi2N {
    color: #343a40;
}

.GapsyShariahList_headerRight__PmGNN {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Search */

.GapsyShariahList_searchGroup__9Iktp {
    width: 300px;
}

.GapsyShariahList_searchIcon__Nmsn7 {
    background: #fff;
}

.GapsyShariahList_searchInput__DAoHD {
    border-left: none;
}

.GapsyShariahList_searchInput__DAoHD:focus {
    box-shadow: none;
}

/* Add Button */

.GapsyShariahList_addButton__EqW6o {
    border-radius: 10px;
    padding: 8px 18px;
}

/* Table */

.GapsyShariahList_tableCard__quwC3 {
    background: #fff;
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(0,0,0,.08);
}

.GapsyShariahList_tableHeader__nrCMf th {
    background: #f8f9fa;
    color: #495057;
    vertical-align: middle;
}

.GapsyShariahList_tableRow__OCr8w {
    height: 78px;
}

.GapsyShariahList_tableRow__OCr8w td {
    vertical-align: middle;
}

/* Left Icons */

.GapsyShariahList_iconBox__b\\+Cst {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.GapsyShariahList_iconRed__PFNA5 {
    background: #fdecec;
    color: #dc3545;
}

.GapsyShariahList_iconBlue__RoTxw {
    background: #eef4ff;
    color: #0d6efd;
}

.GapsyShariahList_iconOrange__vz7Cs {
    background: #fff5e6;
    color: #ff9800;
}

.GapsyShariahList_iconPurple__c4-WP {
    background: #f2ebff;
    color: #7c4dff;
}

.GapsyShariahList_iconGreen__0uw2U {
    background: #e8f7ee;
    color: #28a745;
}

.GapsyShariahList_dateText__qtP7V {
    margin-left: 14px;
    color: #495057;
}

/* Status */

.GapsyShariahList_statusBadge__YhWvM {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 16px;
    border-radius: 10px;
    border: 1px solid;
    text-align: left;
}

.GapsyShariahList_saved__SkNHR {
    background: #eaf8ef;
    color: #2e9d55;
    border-color: #bfe9cc;
}

.GapsyShariahList_review__gQdns {
    background: #fff7e8;
    color: #d88900;
    border-color: #ffd68a;
}

.GapsyShariahList_returned__Z6j3G {
    background: #f3f4f8;
    color: #5c6784;
    border-color: #d8dce7;
}

.GapsyShariahList_approved__reK27 {
    background: #eaf8ef;
    color: #2d9d54;
    border-color: #bfe9cc;
}

/* Action */

.GapsyShariahList_actionButton__yRODg {
    border-radius: 10px;
    padding: 6px 16px;
}

.GapsyShariahList_moreIcon__knqVq {
    cursor: pointer;
    color: #6c757d;
}

.GapsyShariahList_moreIcon__knqVq:hover {
    color: #0d6efd;
}

.GapsyShariahList_userInfo__Y5Yp8 {
    display: flex;
    align-items: center;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/GapsyShariahList.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,aAAa;AACjB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,WAAW;;AAEX;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,eAAe;;AAEf;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,UAAU;;AAEV;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,eAAe;;AAEf;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,WAAW;;AAEX;IACI,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,WAAW;;AAEX;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":[".pageContainer {\r\n    max-width: 1200px;\r\n    margin: auto;\r\n    padding: 20px;\r\n}\r\n\r\n/* Header */\r\n\r\n.header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin-bottom: 25px;\r\n    flex-wrap: wrap;\r\n    gap: 15px;\r\n}\r\n\r\n.title {\r\n    color: #343a40;\r\n}\r\n\r\n.headerRight {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n}\r\n\r\n/* Search */\r\n\r\n.searchGroup {\r\n    width: 300px;\r\n}\r\n\r\n.searchIcon {\r\n    background: #fff;\r\n}\r\n\r\n.searchInput {\r\n    border-left: none;\r\n}\r\n\r\n.searchInput:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n/* Add Button */\r\n\r\n.addButton {\r\n    border-radius: 10px;\r\n    padding: 8px 18px;\r\n}\r\n\r\n/* Table */\r\n\r\n.tableCard {\r\n    background: #fff;\r\n    border-radius: 14px;\r\n    overflow: hidden;\r\n    box-shadow: 0 2px 12px rgba(0,0,0,.08);\r\n}\r\n\r\n.tableHeader th {\r\n    background: #f8f9fa;\r\n    color: #495057;\r\n    vertical-align: middle;\r\n}\r\n\r\n.tableRow {\r\n    height: 78px;\r\n}\r\n\r\n.tableRow td {\r\n    vertical-align: middle;\r\n}\r\n\r\n/* Left Icons */\r\n\r\n.iconBox {\r\n    width: 38px;\r\n    height: 38px;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.iconRed {\r\n    background: #fdecec;\r\n    color: #dc3545;\r\n}\r\n\r\n.iconBlue {\r\n    background: #eef4ff;\r\n    color: #0d6efd;\r\n}\r\n\r\n.iconOrange {\r\n    background: #fff5e6;\r\n    color: #ff9800;\r\n}\r\n\r\n.iconPurple {\r\n    background: #f2ebff;\r\n    color: #7c4dff;\r\n}\r\n\r\n.iconGreen {\r\n    background: #e8f7ee;\r\n    color: #28a745;\r\n}\r\n\r\n.dateText {\r\n    margin-left: 14px;\r\n    color: #495057;\r\n}\r\n\r\n/* Status */\r\n\r\n.statusBadge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    padding: 8px 16px;\r\n    border-radius: 10px;\r\n    border: 1px solid;\r\n    text-align: left;\r\n}\r\n\r\n.saved {\r\n    background: #eaf8ef;\r\n    color: #2e9d55;\r\n    border-color: #bfe9cc;\r\n}\r\n\r\n.review {\r\n    background: #fff7e8;\r\n    color: #d88900;\r\n    border-color: #ffd68a;\r\n}\r\n\r\n.returned {\r\n    background: #f3f4f8;\r\n    color: #5c6784;\r\n    border-color: #d8dce7;\r\n}\r\n\r\n.approved {\r\n    background: #eaf8ef;\r\n    color: #2d9d54;\r\n    border-color: #bfe9cc;\r\n}\r\n\r\n/* Action */\r\n\r\n.actionButton {\r\n    border-radius: 10px;\r\n    padding: 6px 16px;\r\n}\r\n\r\n.moreIcon {\r\n    cursor: pointer;\r\n    color: #6c757d;\r\n}\r\n\r\n.moreIcon:hover {\r\n    color: #0d6efd;\r\n}\r\n\r\n.userInfo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `GapsyShariahList_pageContainer__xrF-h`,
	"header": `GapsyShariahList_header__itBy6`,
	"title": `GapsyShariahList_title__4Mi2N`,
	"headerRight": `GapsyShariahList_headerRight__PmGNN`,
	"searchGroup": `GapsyShariahList_searchGroup__9Iktp`,
	"searchIcon": `GapsyShariahList_searchIcon__Nmsn7`,
	"searchInput": `GapsyShariahList_searchInput__DAoHD`,
	"addButton": `GapsyShariahList_addButton__EqW6o`,
	"tableCard": `GapsyShariahList_tableCard__quwC3`,
	"tableHeader": `GapsyShariahList_tableHeader__nrCMf`,
	"tableRow": `GapsyShariahList_tableRow__OCr8w`,
	"iconBox": `GapsyShariahList_iconBox__b+Cst`,
	"iconRed": `GapsyShariahList_iconRed__PFNA5`,
	"iconBlue": `GapsyShariahList_iconBlue__RoTxw`,
	"iconOrange": `GapsyShariahList_iconOrange__vz7Cs`,
	"iconPurple": `GapsyShariahList_iconPurple__c4-WP`,
	"iconGreen": `GapsyShariahList_iconGreen__0uw2U`,
	"dateText": `GapsyShariahList_dateText__qtP7V`,
	"statusBadge": `GapsyShariahList_statusBadge__YhWvM`,
	"saved": `GapsyShariahList_saved__SkNHR`,
	"review": `GapsyShariahList_review__gQdns`,
	"returned": `GapsyShariahList_returned__Z6j3G`,
	"approved": `GapsyShariahList_approved__reK27`,
	"actionButton": `GapsyShariahList_actionButton__yRODg`,
	"moreIcon": `GapsyShariahList_moreIcon__knqVq`,
	"userInfo": `GapsyShariahList_userInfo__Y5Yp8`
};
export default ___CSS_LOADER_EXPORT___;
